module.exports = __webpack_public_path__ + "img/TreasuryOrgCardBackground.3b636da4.svg";